import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { BookingDatesHouseFragment, Maybe } from '../../../../lib/graphql'
import { useDateFormatter } from '../../../../lib/hooks'

const BookingDates = ({
  startDate,
  endDate,
  house,
  isEarlyCheckin,
  isLateCheckout,
}: {
  startDate: Date
  endDate: Date
  house?: Maybe<BookingDatesHouseFragment>
  isEarlyCheckin: boolean
  isLateCheckout: boolean
}) => {
  const dateFormatter = useDateFormatter()

  return (
    <div className={s.dates}>
      <div className={s.arrival}>
        <div className={s.title}>
          <FormattedMessage
            id='ui.BookingDates.arrival'
            defaultMessage='Arrivée'
          />
        </div>
        <span>
          {dateFormatter.format({ date: startDate, formatString: 'fullDate' })}
        </span>
        <span>
          <span>{isEarlyCheckin ? '10h00' : house?.arrival || '15h00'}</span>
        </span>
      </div>
      <div className={s.bar}></div>
      <div className={s.departure}>
        <div className={s.title}>
          <FormattedMessage
            id='ui.BookingDates.departure'
            defaultMessage='Départ'
          />
        </div>
        <span>
          {dateFormatter.format({ date: endDate, formatString: 'fullDate' })}
        </span>
        <span>{isLateCheckout ? '18h00' : house?.departure || '11h00'}</span>
      </div>
    </div>
  )
}

export default BookingDates
